export default {
  root: {
    padding: 40,
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  thumbnail: {
    width: 200,
    height: 100,
  },
  button: {
    margin: 10,
  },
}
